import { Button, Popover, PopoverTrigger, SkeletonRect, Stack } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { TextCell } from '@common/components/TextCell';

import { useGetOrderPaymentFai } from '../../api/useGetOrderPaymentFai';
import { FaiAftermarketDetails } from '../order-payment/FaiAftermarketSection';


interface FinanceAndInsuranceCellProps {
	displayText?: string;
	purchasedVehicleId: string;
	itemsCount?: number;
}

const PopoverContent = ({ purchasedVehicleId }: { purchasedVehicleId: string }) => {
	const { data: orderPaymentFai, isLoading } = useGetOrderPaymentFai(purchasedVehicleId);

	const faiAftermarket = orderPaymentFai?.faiAftermarket;

	return (
		<div style={{ width: 360 }}>
			<Stack itemsSpacing='8'>
				{isLoading ? (
					<SkeletonRect width='100%' height={120} />
				) : (
					<FaiAftermarketDetails faiAftermarket={faiAftermarket} />
				)}
			</Stack>
		</div>
	);
};

export const FinanceAndInsuranceCell = ({
	displayText,
	purchasedVehicleId,
	itemsCount,
}: FinanceAndInsuranceCellProps) => {
	// If there are no items, just show the text without the dropdown
	if (!itemsCount || itemsCount === 0) {
		return <TextCell value={displayText} />;
	}

	// PopoverContent only renders when popover is open, so the hook will only be called then
	return (
		<PopoverTrigger>
			<Button
				className='fi-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<TextCell value={displayText} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent purchasedVehicleId={purchasedVehicleId} />
			</Popover>
		</PopoverTrigger>
	);
};
